<template>
    <v-flex xs12>
        <v-card hover flat :class="['sale-container', {'hover': hover}]" @mouseover="hover=true" @mouseout="hover=false">
            <v-img
                    :src="sale.image"
                    height="200px"
            >
            </v-img>

            <discount-label :discount="sale.discount"></discount-label>

            <v-card-title primary-title>
                <div>
                    <div class="headline font-weight-light">{{sale.title}}</div>
                    <span class="grey--text">{{sale.service_item.description}}</span>
                </div>
                <v-spacer></v-spacer>
                <kimsa-countdown v-if="sale.show_timer" :date="sale.expires_at"></kimsa-countdown>
            </v-card-title>

            <v-card-actions>
                <v-btn flat class="font-weight-light" @click="showQuotationForm=true">Solicitar</v-btn>
                <v-btn flat class="font-weight-light" @click="show = !show" color="primary">Detalles
                    <v-icon>{{ show ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>

            <v-slide-y-transition>
                <v-card-text v-show="show">
                    {{sale.description}}
                </v-card-text>
            </v-slide-y-transition>
        </v-card>

        <quotation-request-form
                v-if="sale"
                :show="showQuotationForm"
                v-on:change="onQuotationDialogChange"
                :special-sale-id="sale.id"
        >
        </quotation-request-form>

    </v-flex>

</template>


<script>

    import DiscountLabel from './DiscountLabel.vue'
    import KimsaCountdown from '@/components/common/KimsaCountdown'
    import QuotationRequestForm from '@/components/providers/QuotationRequestForm'

    export default{
        props: ['sale'],
        components: {
            DiscountLabel,
            KimsaCountdown,
            QuotationRequestForm
        },
        methods: {
            onQuotationDialogChange(val){
                this.showQuotationForm = val
            }
        },
        data(){
            return{
                show: false,
                hover: false,
                showQuotationForm: false
            }
        }
    }
</script>

<style scoped>

    >>>.v-image__image.v-image__image--cover{
        transition: .3s transform !important;
    }

    .sale-container.hover >>>.v-image__image.v-image__image--cover{
        transform: scale(1.1) !important;
   }

</style>